
(function(){
  function initAhukiniMobileCRO(){
    document.querySelectorAll('[data-ah-product]').forEach(function(section){
      if(section.dataset.ahMobileCRO==='1') return;
      section.dataset.ahMobileCRO='1';
      var media=section.querySelector('.ah-product-main-media');
      var prev=section.querySelector('.ah-gallery-prev');
      var next=section.querySelector('.ah-gallery-next');
      if(media && prev && next){
        var startX=0,startY=0,tracking=false;
        media.addEventListener('touchstart',function(e){
          if(!e.touches || e.touches.length!==1) return;
          startX=e.touches[0].clientX; startY=e.touches[0].clientY; tracking=true;
        },{passive:true});
        media.addEventListener('touchend',function(e){
          if(!tracking || !e.changedTouches || !e.changedTouches.length) return;
          tracking=false;
          var dx=e.changedTouches[0].clientX-startX;
          var dy=e.changedTouches[0].clientY-startY;
          if(Math.abs(dx)>48 && Math.abs(dx)>Math.abs(dy)*1.15){
            (dx<0?next:prev).click();
          }
        },{passive:true});
      }
      var thumbs=Array.prototype.slice.call(section.querySelectorAll('.ah-product-thumb'));
      if(thumbs.length){
        var syncActive=function(){
          var active=section.querySelector('.ah-product-thumb.is-active');
          if(active && window.matchMedia('(max-width: 989px)').matches){
            try{active.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}catch(e){}
          }
        };
        var mo=new MutationObserver(syncActive);
        thumbs.forEach(function(t){mo.observe(t,{attributes:true,attributeFilter:['class']});});
      }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAhukiniMobileCRO,{once:true});
  else initAhukiniMobileCRO();
  document.addEventListener('shopify:section:load',initAhukiniMobileCRO);
})();
